export default __webpack_public_path__ + "static/media/Icon-feather-download-line.81951e61.svg";